import React from 'react';

import Button from '../components/Button';
import Hero from '../components/Hero';
import IndustryList from '../components/IndustryList';
import CaseStudyCard from '../components/CaseStudyCard';
import { DefaultLogoReel } from '../components/LogoReel';
import USPGrid from '../components/USPGrid';
import { SignupBreakpoint } from '../components/Breakpoint';
import Section from '../components/Section';

const DefaultIndustryTemplate = ({
  pageContext: {
    page: { prefixedTitle, caseStudies, usps, ...page },
  },
  uspTitle,
  uspDescription,
  referenceBreakpoint,
  children,
}) => (
  <React.Fragment>
    <Section>
      <Hero {...page} title={prefixedTitle} alignment="left">
        <Button colour="pink" appearance="outline" href="/contact" size="large">
          Get an Enterprise Demo &#8594;
        </Button>
      </Hero>
    </Section>

    <DefaultLogoReel className="mb-16 md:mb-24" />

    {referenceBreakpoint}

    <Section colour="light">
      <USPGrid title={uspTitle} description={uspDescription} items={usps} />
    </Section>

    <SignupBreakpoint />

    <Section>
      {children}
      <IndustryList entries={caseStudies} Component={CaseStudyCard} />
    </Section>
  </React.Fragment>
);

export default DefaultIndustryTemplate;
